import { render, staticRenderFns } from "./SupporterSendUpdateDetails.vue?vue&type=template&id=8f712e54&"
import script from "./SupporterSendUpdateDetails.vue?vue&type=script&lang=js&"
export * from "./SupporterSendUpdateDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports